import camelize from 'camelize';
import get from 'lodash/get';
import { createConsts, createActions, createReducer } from '../../utils/redux';

const supportedActions = ['ADD_SURVEY', 'REMOVE_SURVEY', 'CLEAR', 'RESTORE'];

export const consts = createConsts('surveys', 'saved', ...supportedActions);
export const actions = createActions(consts);

const initialState = {};

// persistence
const getPersistedState = () => {
  const storedUser = window.storage.getItem('user'); // eslint-disable-line jsx-control-statements/jsx-jcs-no-undef
  const { id } = storedUser ? JSON.parse(storedUser) : {};

  if (id) {
    const persistedState = window.storage.getItem(`saved-surveys-${id}`); // eslint-disable-line jsx-control-statements/jsx-jcs-no-undef

    return persistedState ? JSON.parse(persistedState) : initialState;
  }

  return initialState;
};

const addSurvey = (state, action) => {
  const { userId, surveyId, answers } = action.payload;

  return {
    ...state,
    [userId]: Object.assign({}, get(state, [userId]), {
      [surveyId]: camelize(answers),
    }),
  };
};

const removeSurvey = (state, action) => {
  const { userId, surveyId } = action.payload;

  if (get(state, [userId, surveyId])) {
    const updatedState = state;
    delete updatedState[userId][surveyId];

    return updatedState;
  }

  return state;
};

export default createReducer(initialState, {
  [consts.ADD_SURVEY]: addSurvey,
  [consts.REMOVE_SURVEY]: removeSurvey,
  [consts.CLEAR]: () => initialState,
  [consts.RESTORE]: getPersistedState,
});



// WEBPACK FOOTER //
// ./src/redux/surveys/saved.js